import { fillArr } from '@hglobal/common';
import { LocationModel, LocationDetails, PickupLocation } from '@pt/models';

export function getLocationMock(id: number): LocationModel {
  return {
    id,
    name: `Location ${id}`,
  };
}

export function getLocationsMock(count = 12): LocationModel[] {
  return fillArr(count, i => getLocationMock(i));
}

export function getDetailLocationMock(id: number): LocationDetails {
  return {
    ...getLocationMock(id),
    country: 'Ukraine',
    city: 'Kyiv',
    address: 'Verkhnyi Val 72',
  };
}

export function getDetailLocationsMock(count = 12): LocationDetails[] {
  return fillArr(count, i => getDetailLocationMock(i));
}

export function getPickupLocationMock(id: number): PickupLocation {
  return {
    ...getDetailLocationMock(id),
    displayName: `Location ${id}`,
  };
}

export function getPickupLocationsMock(count = 12): PickupLocation[] {
  return fillArr(count, i => getPickupLocationMock(i));
}
